module.exports = __webpack_public_path__ + "media/images/logo-bom-admin-3a09b4d4.png";